import Form from "./Form/Form";
import "./ContactMe.scss";
import ContactSideBar from "./ContactSideBar/ContactSideBar";
import { useState } from "react";
import ThankYou from "./ThankYou/ThankYou";
import openUrlInNewTab from "../../utils/openLink";
import { toast } from "react-toastify";

export default function ContactMe() {
  const [view, setView] = useState<"form" | "thank">("form");
  const [form] = useState({ name: "", email: "", message: "" });
  const handleCopyClick = async (text: any) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.info("Text copied to clipboard!");
    } catch (error) {
      toast.error(`Failed to copy text: ${error}`);
    }
  };

  return (
    <div className="contact-layout">
      <div className="contact-layout__contact-me">_contact-me</div>
      <div className="contact-layout__sidebar">
        <ContactSideBar
          openFile={(e) => {
            if (e.id === "email" || e.id === "phone") {
              handleCopyClick(e.label);
            } else {
              openUrlInNewTab(e.link);
            }
          }}
        />
      </div>
      <div className="contact-layout__code">
        <div className="contact-layout__code-container">
          <div className="contact-layout__body">
            {view === "form" ? (
              <Form
                data={form}
                setView={() => {
                  setView("thank");
                }}
              />
            ) : (
              <ThankYou sendNew={() => setView("form")} />
            )}
          </div>
          {/* <div className="contact-layout__code-snippet">dsd</div> */}
        </div>
      </div>
    </div>
  );
}
